import React, {
    useState
} from 'react';
import {
    Link
} from 'react-router-dom';
import './rentalService.css';

const ledGuides = [
    {
        id: 1,
        image: '/images/rental-guide/rental-hero.png',
        icon: 'mdi-home-outline',
        title: '실내용 / 실외용 구분',
        description:
            'LED 전광판 렌탈 시 설치 장소에 따라 실내용과 실외용으로 구분됩니다. 실내는 근거리 시청 환경을, 실외는 높은 밝기와 주변 환경을 함께 고려해야 합니다.'
    },
    {
        id: 2,
        image: '/images/rental-guide/led-brightness-module.png',
        icon: 'mdi-white-balance-sunny',
        title: '밝기 조절과 모듈 선택',
        description:
            '설치 환경의 밝기와 전광판 크기를 고려하여 적절한 밝기와 모듈을 선택해야 선명하고 안정적인 화면을 구현할 수 있습니다.'
    },
    {
        id: 3,
        image: '/images/rental-guide/led-waterproof.png',
        icon: 'mdi-shield-check-outline',
        title: '방수 · 방진 기준 확인',
        description:
            '실외용 LED 전광판은 외부 환경에 노출되므로 방수와 방진에 대한 규격 기준을 확인하고 현장에 적합한 제품을 선택해야 합니다.'
    },
    {
        id: 4,
        image: '/images/rental-guide/led-pixel-pitch.png',
        icon: 'mdi-magnify',
        title: '픽셀 피치와 가시거리',
        description:
            '사용 용도와 목적에 따라 픽셀 피치, 전광판의 크기, 가시거리를 함께 고려하면 보다 적절한 화면을 구성할 수 있습니다.'
    },
    {
        id: 5,
        image: '/images/rental-guide/led-dip-smd.png',
        icon: 'mdi-view-grid-outline',
        title: 'DIP / SMD 모듈 차이',
        description:
            'LED 전광판은 소자가 빛을 내며 영상을 구현하며, 소자의 방식은 DIP와 SMD 타입의 모듈로 나뉩니다. 설치 환경과 목적에 따라 적절한 타입을 선택합니다.'
    },
    {
        id: 6,
        image: '/images/rental-guide/led-long-use.png',
        icon: 'mdi-cog-outline',
        title: '사용 환경과 운영',
        description:
            'LED는 다양한 행사와 공간에서 활용할 수 있으며, 장시간 운영 시에는 전원 공급과 설치 환경, 장비 상태를 함께 고려하는 것이 중요합니다.'
    }
];

const projectorGuides = [
    {
        id: 1,
        image: '/images/rental-guide/projector-ansi.png',
        icon: 'mdi-white-balance-sunny',
        title: '밝기(ANSI)와 해상도',
        description:
            '사용 환경의 밝기와 스크린 크기에 맞는 밝기를 선택하고, 기기 간 해상도 호환성도 함께 확인합니다.'
    },
    {
        id: 2,
        image: '/images/rental-guide/projector-type.png',
        icon: 'mdi-layers-outline',
        title: '프로젝터 종류',
        description:
            'LCD·3LCD, DLP 등 방식에 따라 특성이 다르므로 사용 목적과 설치 환경에 맞게 선택합니다.'
    },
    {
        id: 3,
        image: '/images/rental-guide/projector-install.png',
        icon: 'mdi-wrench-outline',
        title: '설치 방식',
        description:
            '고정 설치인지 이동형 사용인지에 따라 장비 형태와 설치 방식을 선택합니다.'
    },
    {
        id: 4,
        image: '/images/rental-guide/projector-screen.png',
        icon: 'mdi-monitor',
        title: '스크린 선택과 GAIN',
        description:
            '스크린의 크기와 재질, GAIN, 시청각도를 고려해 화면 밝기와 가독성을 높입니다.'
    },
    {
        id: 5,
        image: '/images/rental-guide/projector-system.png',
        icon: 'mdi-chart-bar',
        title: '사용 시스템 그래픽 확인',
        description:
            '노트북이나 컴퓨터의 출력 해상도, 영상 단자, 입력 소스 설정을 미리 확인합니다.'
    }
];

const troubleshooting = [
    {
        id: 1,
        title: '빔프로젝터 전원이 들어오지 않을 때',
        content: [
            '전원코드 연결이 확실히 되어 있는지 확인합니다.',
            '램프 덮개와 에어필터의 문이 제대로 닫혀 있는지 점검합니다.',
            '제품에 따라 램프의 기본 사용시간이 초과되면 자동으로 전원이 차단될 수 있습니다.'
        ]
    },
    {
        id: 2,
        title: '영상이 나타나지 않을 때',
        content: [
            '입력소스와 프로젝터 출력이 정확한지 확인합니다. 본체의 SOURCE, INPUT 상태를 확인해주세요.',
            '일시정지 또는 화면차단 모드로 설정되어 있는지 확인합니다.',
            '입력소스의 라인 상태를 확인하고 케이블을 제거한 후 다시 연결합니다.'
        ]
    },
    {
        id: 3,
        title: '프로젝터와 노트북 연결',
        content: [
            '노트북의 자체출력모드(LCD/CRT)를 확인합니다.',
            '삼성 노트북은 Fn키와 F5키를 동시에 누르는 방식이 사용될 수 있습니다.',
            '대우 노트북은 F2키와 Del키를 동시에 누르는 방식이 사용될 수 있습니다.',
            'IBM 노트북은 Fn키와 F8키를 동시에 누르는 방식이 사용될 수 있습니다.',
            '노트북 종류에 따라 차이가 있으므로 키보드의 LCD/CRT 변환키를 확인해주세요.'
        ]
    },
    {
        id: 4,
        title: '공기필터 청소법',
        content: [
            '전원 코드를 제거합니다.',
            '공기필터 덮개를 엽니다.',
            '진공청소기 등을 이용하여 공기필터를 청소합니다.',
            '청소 후 공기필터 덮개를 다시 정확하게 부착합니다.'
        ]
    }
];

const RentalService = () => {
    const [selectedGuide, setSelectedGuide] =
        useState('led');

    const [openedTrouble, setOpenedTrouble] =
        useState(null);

    const handleGuideChange = (guide) => {
        setSelectedGuide(guide);
        setOpenedTrouble(null);

        requestAnimationFrame(() => {
            const section =
                document.getElementById(
                    'rental-guide-content'
                );

            if (!section) {
                return;
            }

            const headerHeight = 80;

            const top =
                section
                    .getBoundingClientRect()
                    .top +
                window.scrollY -
                headerHeight;

            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        });
    };

    const toggleTrouble = (id) => {
        setOpenedTrouble((prev) =>
            prev === id
                ? null
                : id
        );
    };

    const currentGuides =
        selectedGuide === 'led'
            ? ledGuides
            : projectorGuides;

    return (
        <div className="rental-service-page">

            {/* SUB VISUAL */}
            <section className="rental-service-hero">
                <div className="rental-service-hero-overlay"></div>

                <div className="rental-service-hero-inner">
                    <p>
                        RENTAL SERVICE
                    </p>

                    <h1>
                        서비스 가이드
                    </h1>

                    <div className="rental-service-breadcrumb">
                        <Link to="/">
                            HOME
                        </Link>

                        <span>
                            ›
                        </span>

                        <strong>
                            서비스 가이드
                        </strong>
                    </div>
                </div>
            </section>

            {/* GUIDE SELECT */}
            <section className="rental-guide-select">

                <div className="rental-guide-select-inner">

                    <div className="rental-guide-select-heading">

                        <p>
                            EQUIPMENT GUIDE
                        </p>

                        <h2>
                            어떤 장비가 궁금하신가요?
                        </h2>

                        <span>
                            필요한 장비를 선택하시면
                            렌탈 전 확인해야 할 주요 내용을 안내해드립니다.
                        </span>

                    </div>

                    <div className="rental-guide-select-buttons">

                        <button
                            type="button"
                            className={
                                selectedGuide === 'led'
                                    ? 'active'
                                    : ''
                            }
                            onClick={() =>
                                handleGuideChange(
                                    'led'
                                )
                            }
                        >
                            <div>
                                <i className="mdi mdi-view-grid-outline"></i>
                            </div>

                            <span>
                                GUIDE 01
                            </span>

                            <strong>
                                LED 전광판 가이드
                            </strong>

                            <p>
                                설치환경 · 픽셀피치 · 모듈 · 방수방진
                            </p>
                        </button>

                        <button
                            type="button"
                            className={
                                selectedGuide === 'projector'
                                    ? 'active'
                                    : ''
                            }
                            onClick={() =>
                                handleGuideChange(
                                    'projector'
                                )
                            }
                        >
                            <div>
                                <i className="mdi mdi-projector"></i>
                            </div>

                            <span>
                                GUIDE 02
                            </span>

                            <strong>
                                빔프로젝터 가이드
                            </strong>

                            <p>
                                밝기 · 해상도 · 설치 · 스크린 · 문제해결
                            </p>
                        </button>

                    </div>

                </div>

            </section>

            {/* GUIDE CONTENT */}
            <section
                id="rental-guide-content"
                className="rental-guide-content"
            >

                <div className="rental-guide-container">

                    <div className="rental-guide-main">

                        <div className="rental-guide-heading">

                            <p>
                                {selectedGuide === 'led'
                                    ? 'GUIDE 01'
                                    : 'GUIDE 02'
                                }
                            </p>

                            <h2>
                                {selectedGuide === 'led'
                                    ? 'LED 전광판 가이드'
                                    : '빔프로젝터 선택 가이드'
                                }
                            </h2>

                            <span>
                                {selectedGuide === 'led'
                                    ? '행사, 전시, 공연 등 다양한 환경에 적합한 LED 전광판 렌탈을 위해 꼭 알아야 할 주요 포인트를 안내합니다.'
                                    : '빔프로젝터 대여 · 렌탈 시 용도와 환경에 맞는 제품을 선택할 수 있도록 주요 체크포인트를 안내합니다.'
                                }
                            </span>

                        </div>

                        <div
                            className={
                                selectedGuide === 'led'
                                    ? 'rental-guide-grid led'
                                    : 'rental-guide-grid projector'
                            }
                        >

                            {currentGuides.map(
                                (guide) => (
                                    <article
                                        className="rental-guide-card"
                                        key={guide.id}
                                    >

                                        <div className="rental-guide-card-image">

                                            <img
                                                src={guide.image}
                                                alt={guide.title}
                                            />

                                            <span>
                                                <i
                                                    className={
                                                        `mdi ${guide.icon}`
                                                    }
                                                ></i>
                                            </span>

                                        </div>

                                        <div className="rental-guide-card-content">

                                            <h3>
                                                {guide.title}
                                            </h3>

                                            <p>
                                                {guide.description}
                                            </p>

                                        </div>

                                    </article>
                                )
                            )}

                        </div>

                        {selectedGuide === 'projector' && (
                            <>

                                <div className="projector-guide-detail">

                                    <div className="projector-guide-detail-heading">

                                        <p>
                                            PROJECTOR GUIDE
                                        </p>

                                        <h2>
                                            빔프로젝터 선택 시
                                            함께 확인해주세요.
                                        </h2>

                                    </div>

                                    <div className="projector-guide-detail-grid">

                                        <div>
                                            <strong>
                                                밝기와 해상도
                                            </strong>

                                            <p>
                                                ANSI 루멘은 프로젝터의 밝기를 나타내는 대표적인 기준입니다. 수치가 높을수록 주변 조명이 있는 환경에서도 화면을 보다 선명하게 확인하는 데 유리합니다.
                                            </p>

                                            <p>
                                                사용할 노트북이나 컴퓨터의 출력 해상도와 프로젝터의 지원 해상도도 함께 확인하여 장비 간 호환성을 고려하는 것이 좋습니다.
                                            </p>
                                        </div>

                                        <div>
                                            <strong>
                                                설치 환경
                                            </strong>

                                            <p>
                                                강당, 회의실, 교육장 등 일정한 장소에서 사용하는 경우에는 천장 또는 고정 설치 방식을 활용할 수 있습니다. 반면 여러 장소에서 장비를 사용하는 경우에는 이동과 설치가 편리한 제품을 선택하는 것이 좋습니다.
                                            </p>

                                            <p>
                                                탁상 설치는 프로젝터의 위치와 투사 각도를 정확하게 설정하는 것이 중요하며, 이동형 장비는 운반 과정에서의 충격과 장비 관리에 주의해야 합니다.
                                            </p>
                                        </div>

                                        <div>
                                            <strong>
                                                스크린 선택
                                            </strong>

                                            <p>
                                                스크린은 재질과 표면 특성에 따라 화면의 밝기와 시인성이 달라질 수 있습니다. 설치 환경과 사용 목적에 맞는 스크린을 선택하는 것이 중요합니다.
                                            </p>

                                            <p>
                                                스크린의 크기와 GAIN(반사 특성), 시청각도 등을 함께 고려해야 하며, 프로젝터의 투사거리와 렌즈 특성에 따라 구현할 수 있는 화면 크기도 달라집니다.
                                            </p>
                                        </div>

                                    </div>

                                </div>

                                {/* TROUBLESHOOTING */}
                                <div className="rental-trouble">

                                    <div className="rental-trouble-heading">

                                        <p>
                                            GUIDE 03
                                        </p>

                                        <h2>
                                            문제발생시 긴급 대처법
                                        </h2>

                                        <span>
                                            빔프로젝터 사용 중 문제가 발생했을 때
                                            아래 내용을 순서대로 확인해주세요.
                                        </span>

                                    </div>

                                    <div className="rental-trouble-list">

                                        {troubleshooting.map(
                                            (item, index) => (
                                                <div
                                                    className={
                                                        openedTrouble === item.id
                                                            ? 'rental-trouble-item active'
                                                            : 'rental-trouble-item'
                                                    }
                                                    key={item.id}
                                                >

                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            toggleTrouble(
                                                                item.id
                                                            )
                                                        }
                                                    >

                                                        <span className="rental-trouble-number">
                                                            {String(
                                                                index + 1
                                                            ).padStart(
                                                                2,
                                                                '0'
                                                            )}
                                                        </span>

                                                        <strong>
                                                            {item.title}
                                                        </strong>

                                                        <i
                                                            className={
                                                                openedTrouble === item.id
                                                                    ? 'mdi mdi-chevron-up'
                                                                    : 'mdi mdi-chevron-down'
                                                            }
                                                        ></i>

                                                    </button>

                                                    {openedTrouble === item.id && (
                                                        <div className="rental-trouble-answer">

                                                            {item.content.map(
                                                                (
                                                                    content,
                                                                    contentIndex
                                                                ) => (
                                                                    <p
                                                                        key={
                                                                            contentIndex
                                                                        }
                                                                    >
                                                                        <span>
                                                                            ·
                                                                        </span>

                                                                        {content}
                                                                    </p>
                                                                )
                                                            )}

                                                        </div>
                                                    )}

                                                </div>
                                            )
                                        )}

                                    </div>

                                </div>

                            </>
                        )}

                    </div>

                    {/* QUICK CONSULTATION */}
                    <aside className="rental-quick">

                        <p className="rental-quick-label">
                            QUICK CONSULTATION
                        </p>

                        <h2>
                            빠른 상담이
                            <br />
                            필요하신가요?
                        </h2>

                        <p className="rental-quick-description">
                            행사, 전시, 공연, 기업행사 등
                            어떤 현장이든 최적의 장비와
                            운영방안을 제안해드립니다.
                        </p>

                        <a
                            href="tel:01090453707"
                            className="rental-quick-phone"
                        >
                            <i className="mdi mdi-phone"></i>

                            010-9045-3707
                        </a>

                        <span className="rental-quick-time">
                            평일 09:00 - 18:00
                        </span>

                        <Link
                            to="/inquiry"
                            className="rental-quick-inquiry"
                        >
                            견적문의 바로가기

                            <i className="mdi mdi-arrow-right"></i>
                        </Link>

                        <a
                            href="tel:01090453707"
                            className="rental-quick-call"
                        >
                            <i className="mdi mdi-phone-outline"></i>

                            전화 상담하기
                        </a>

                        <div className="rental-quick-divider">
                        </div>

                        <div className="rental-quick-service">

                            <div>
                                <i className="mdi mdi-calendar-check-outline"></i>

                                <span>
                                    <strong>
                                        행사 맞춤 견적
                                    </strong>

                                    빠르고 정확한 견적 제공
                                </span>
                            </div>

                            <div>
                                <i className="mdi mdi-truck-outline"></i>

                                <span>
                                    <strong>
                                        전국 설치 가능
                                    </strong>

                                    전문 기사 현장 지원
                                </span>
                            </div>

                            <div>
                                <i className="mdi mdi-cog-outline"></i>

                                <span>
                                    <strong>
                                        장비 운영 가이드
                                    </strong>

                                    설치부터 운영까지 지원
                                </span>
                            </div>

                        </div>

                    </aside>

                </div>

            </section>

            {/* CTA */}
            <section className="rental-bottom-cta">

                <div className="rental-bottom-cta-overlay">
                </div>

                <div className="rental-bottom-cta-inner">

                    <div>

                        <p>
                            MTMEDIA CONSULTATION
                        </p>

                        <h2>
                            행사에 딱 맞는 영상 솔루션,
                            지금 상담받으세요.
                        </h2>

                        <span>
                            LED 전광판, 빔프로젝터 등
                            현장에 최적화된 장비와 운영 방안을 제안해드립니다.
                        </span>

                    </div>

                    <Link
                        to="/inquiry"
                        className="rental-bottom-button"
                    >
                        견적문의 바로가기

                        <i className="mdi mdi-arrow-right"></i>
                    </Link>

                </div>

            </section>

        </div>
    );
};

export default RentalService;